/**
 * إصدارات النماذج والمنطق المعتمدة في PHASE 1.
 *
 * هذه الإصدارات تُنشر مع كل مخرَج (Evaluation Contract / Lineage) حتى نستطيع
 * لاحقاً تتبّع أي رقم إلى النسخة التي أنتجته.
 *
 * تحذير: وجود الإصدار هنا لا يعني أن الخوارزمية منفّذة. في PHASE 1 كل القيم
 * تأتي من DemoMarketDataProvider ولا يوجد أي محرّك تقييم حقيقي.
 */
export const MODEL_VERSIONS = {
  /** Normalization — تحويل السجل الخام إلى الشكل القانوني */
  NRM: 'NRM-1.0',
  /** Property Identity — مطابقة نفس العقار عبر عدة مصادر (غير منفّذة) */
  PI: 'PI-1.0',
  /** Comparable Selection — اختيار الصفقات المماثلة (غير منفّذة) */
  CMP: 'CMP-1.0',
  /** Fair Value — نطاق القيمة العادلة (غير منفّذة) */
  FV: 'FV-1.0',
  /** Confidence — الثقة في التقييم (غير منفّذة) */
  CF: 'CF-1.0',
  /** Opportunity — مؤشر الفرصة (غير منفّذة) */
  OP: 'OP-1.0',
  /** Market Pressure — ضغط السوق / قوة المشتري (غير منفّذة) */
  MP: 'MP-1.0',
  /** Explanation — طبقة التفسير والسيناريوهات (غير منفّذة) */
  EXP: 'EXP-1.0',
} as const;

export type ModelVersionKey = keyof typeof MODEL_VERSIONS;
export type ModelVersion = (typeof MODEL_VERSIONS)[ModelVersionKey];

/**
 * الخوارزميات الممنوع تنفيذها في PHASE 1.
 * تُستخدم في الاختبارات كحاجز صريح ضد التسرّب.
 */
export const PHASE_1_NOT_IMPLEMENTED: readonly ModelVersion[] = [
  MODEL_VERSIONS.PI,
  MODEL_VERSIONS.CMP,
  MODEL_VERSIONS.FV,
  MODEL_VERSIONS.CF,
  MODEL_VERSIONS.OP,
  MODEL_VERSIONS.MP,
  MODEL_VERSIONS.EXP,
];
